import { fromCents, toCents } from "../../../utils/billingTotals";

const hasValue = (value) => value !== null && value !== undefined && value !== "";

export const isTruthyBillTaxOverrideFlag = (value) =>
  value === true || value === 1 || value === "1";

export const isValidBillTaxInput = (value, { allowNegative = false } = {}) =>
  value !== "" &&
  Number.isFinite(Number(value)) &&
  (allowNegative || Number(value) >= 0);

export const billTaxInputFromCalculatedTax = (calculatedTaxCents = 0) =>
  String(fromCents(calculatedTaxCents));

export const shouldSyncBillTaxInputToCalculated = ({
  billTaxManuallyEdited = false,
  hasLegacyTaxDifference = false,
} = {}) => !billTaxManuallyEdited && !hasLegacyTaxDifference;

export const getInitialBillTaxOverrideState = ({
  bill = {},
  calculatedTaxCents = 0,
} = {}) => {
  const isPersistedOverride = isTruthyBillTaxOverrideFlag(bill?.isTaxOverridden);
  const hasMetadata =
    bill?.calculatedTotalTax != null ||
    bill?.taxOverrideAmount != null ||
    isPersistedOverride;
  const savedTax = isPersistedOverride ? bill?.taxOverrideAmount : bill?.totalTax;
  const savedTaxCents = hasValue(savedTax) ? toCents(savedTax) : calculatedTaxCents;

  return {
    billTaxInput: hasValue(savedTax)
      ? String(savedTax)
      : billTaxInputFromCalculatedTax(calculatedTaxCents),
    billTaxManuallyEdited: isPersistedOverride,
    hasLegacyTaxDifference: !hasMetadata && savedTaxCents !== calculatedTaxCents,
  };
};

export const resolveBillTaxPayloadState = ({
  billTaxInput,
  calculatedTaxCents = 0,
  billTaxManuallyEdited = false,
  hasLegacyTaxDifference = false,
  allowNegative = false,
} = {}) => {
  const overrideRequested = billTaxManuallyEdited || hasLegacyTaxDifference;
  const inputIsValid = isValidBillTaxInput(billTaxInput, { allowNegative });
  const effectiveTaxCents =
    overrideRequested && inputIsValid ? toCents(billTaxInput) : calculatedTaxCents;
  const isTaxOverridden = overrideRequested && inputIsValid;

  return {
    billTaxIsValid: !overrideRequested || inputIsValid,
    inputIsValid,
    isValid: !overrideRequested || inputIsValid,
    effectiveTaxCents,
    isTaxOverridden,
    calculatedTotalTax: fromCents(calculatedTaxCents),
    taxOverrideAmount: isTaxOverridden ? fromCents(effectiveTaxCents) : null,
    totalTax: fromCents(effectiveTaxCents),
  };
};

export const resolveBillTaxOverrideState = (args = {}) =>
  resolveBillTaxPayloadState(args);
